/*
 *  Class Form
 */
export
default class Form {
    constructor() {
        this.forms = document.querySelectorAll('.js-form');
    }

    hide(el) {
        el.classList.add('hidden');
    }

    show(el) {
        el.classList.remove('hidden');
    }

    onCheckboxChange(el) {
        const elId = el.target.getAttribute('data-toggle');
        const target = el.target.closest('.js-form').querySelector(`[name="${elId}"]`);
        if (el.target.checked) {
            target.setAttribute('disabled', 'disabled');
        } else {
            target.removeAttribute('disabled');
        }
    }

    hideErrorMsg(el) {
        const msgBox = el.querySelector('.message.error');
        msgBox.classList.add('hidden');
    }

    showErrorMsg(el) {
        const msgBox = el.querySelector('.message.error');
        msgBox.classList.remove('hidden');
    }

    encode(w) {
        return w.replace(/[^]/g, function (w) {
            return '%' + w.charCodeAt(0).toString(16);
        });
    }

    fixedEncodeURIComponent(str) {
        return encodeURIComponent(str).replace(/[!'()*]/g, escape).replace(/\%20/g, '+');
    }

    onSubmit(e) {
        e.preventDefault();
        const self = this;
        const form = e.target.closest('.js-form');
        const formEl = form.querySelector('form');
        const url = formEl.action;
        const xhr = new XMLHttpRequest();
        const formData = [].filter.call(formEl.elements, function (el) {
                return ['radio', 'checkbox'].indexOf(el.type) === -1 || typeof (el.checked) === 'undefined' || el.checked;
            })
            .filter(function (el) {
                return !!el.name;
            })
            .filter(function (el) {
                return el.disabled ? el.disabled : true;
            })
            .map(function (el) {
                return self.fixedEncodeURIComponent(el.name) + '=' + self.fixedEncodeURIComponent(el.value);
            }).join('&');

        form.classList.add('form--submit');

        form.querySelector('.form-panel__loading').classList.remove('hidden');
        form.querySelector('.form-panel__content').classList.add('hidden');

        xhr.open('POST', url);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhr.onload = function () {
            try {
                if (xhr.status >= 200 && xhr.status < 300) {
                    const resp = JSON.parse(xhr.responseText);

                    // Show message by status
                    if (resp.success) {
                        form.querySelector('.form-panel__loading').classList.add('hidden');
                        form.querySelector('.form-panel__content').classList.remove('hidden');
                    } else {
                        throw 418;
                    }
                } else {
                    throw xhr.status;
                }
            } catch (err) {
                self.showErrorMsg(form);
                form.classList.remove('form--submit');
            }
        };
        xhr.ontimeout = function () {
            form.classList.remove('form--submit');
        };
        xhr.onerror = function () {
            form.classList.remove('form--submit');
        };
        xhr.send(formData);
    }

    onGoBack(e) {
        e.preventDefault();
        const form = e.target.closest('.js-form');
        form.classList.remove('form--submit');
        this.hideErrorMsg(form);
    }

    init() {
        for (let i = 0; i < this.forms.length; i++) {
            const form = this.forms[i];
            form.querySelector('form').addEventListener('submit', this.onSubmit.bind(this));

            const backBtns = form.querySelectorAll('.btn-back');
            for (let ii = 0; ii < backBtns.length; ii++) {
              backBtns[ii].addEventListener('click', this.onGoBack.bind(this));
            }

            const toggles = form.querySelectorAll('[data-toggle]');
            toggles.forEach((toggle) => {
                toggle.addEventListener('change', this.onCheckboxChange.bind(this));
            });
        }
    }
}
